module.exports = __webpack_public_path__ + "static/media/Кудрявцева Полина Евгеньевна Разгромная критика и... всенародная любовь Курская обл.-1.png";